module.exports = __webpack_public_path__ + "media/images/new-virtualahan-c694fbdbd1038327a9fbe2f1d45b6cd7.png";